import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import CButton from '@/components/CButton'
import { connect} from 'react-redux'
import './index.scss'
import { setStorage,getStorage} from "@/utils";
import {Dropdown, Icon, Menu, Card, Modal, Button, message, Popconfirm,Empty} from "antd";
import {bindActionCreators, compose} from "redux";
import { withRouter} from 'react-router-dom'
import {
    collapsedToggle,
    setWindowInfo,
    setUserInfo,
    setCurrentTheme,
    setMenu,
    setYear,
    setUserList, setLibrary, setLbname
} from "../../redux/common/action";
import {getALLMenu} from "../../servers/menuAPI";
import { loginout,selecttype, submitdata, resetdata,selectIndex } from "@/servers/commonApi";
import {clearboth} from "../../utils/clear";
import store from "../../redux";

@CBaseComponent
class Home extends Component{
  constructor(props) {
    super(props);
    this.showModal = this.showModal.bind(this)
      this.handleCanceldialog = this.handleCanceldialog.bind(this)
      this.downloads = this.downloads.bind(this)
  }


  state = {
    data: null,
    loading: false,
    isModalVisible: false,
    status: false,
    indexdata:[],
    fileslist:[],
    newslist:[],
    title:'',
    content:'',
    name: '',
    time:'',
    state:'',
    index:-1
  };
   showModal(data){
     this.setState({
       isModalVisible:true
     })
    var newStr = decodeURI(data.content).replaceAll("++++","\n");
   this.setState({
   title:data.title,
   name: data.postedby,
   time:data.postedtime,
   content:newStr
    })
  }
   selectAllMenu(data){
     const params = {
       annual:data,
       museumid:''
     }
     getALLMenu(params).then(res=>{
         const result =  this.changeitem(res.records)
         setStorage('menu', result);
         this.props.setMenu(result);
         setStorage('year', data);
         this.props.setYear(data);
         setStorage('showids','1.1.1')
         const r = store.getState();
         setStorage('lbname', r.userList.museumname);
         this.props.setLbname(r.userList.museumname);
         this.props.setLibrary(r.userList.museumid);
         setStorage('library',r.userList.museumid)
         localStorage.setItem('chooseid','121110')
         this.props.history.push({
         pathname: '/informationDeclaration/museumbaseinfo',
          });
     })
   }
    downloadFile(url,index){
       if (url) {
           window.location.href = url
       } else {
           this.setState({
               index:index
           })
           this.selectdata('download')
       }
    }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }

   async handleCancel(){
     await resetdata().then(async res=>{
       if (res.statecode === 0) {
         message.success('撤销成功');
         await this.selectdata()
         this.setState({
           status: true
         })
       } else {
         message.error(res.statemessage);
       }
     })
  }

    handleCanceldialog(){
        this.setState({
            title: '',
            content:'',
            isModalVisible: false
        })
    }

    downloads(data){
       window.open(data.fileurl,"_blank");
    }

 async handleSubmit(){
    await submitdata().then(async res=>{
      if (res.statecode === 0) {
        message.success('提交成功');
        await this.selectdata()
        this.setState({
          status: true
        })

      } else {
        message.error(res.statemessage);
      }
    })
  }

  menuClick(data){
      const userInfo = getStorage('userList')
      const result =  this.changeitem(userInfo.menulist)
      result.splice(1,1)
      setStorage('menu', result);
      this.props.setMenu(result);
      this.props.history.push({
          pathname: '/personinfo',
      });
  }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }

  logout(){
      Modal.confirm({
          content: '确认退出系统？',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
              loginout().then(res => {
                  if (res.statecode === 0) {
                      window.location.href = '/'
                      clearboth()
                  } else {
                      message.error(res.statemessage);
                  }
              })
          }
      })
  }


  componentWillReceiveProps(nextProps){

  }

  componentWillMount(){
    const {id} = this.props.userInfo || {};
    if (id === 'users' || id === 'admin') {
     this.props.history.push({
       pathname:'/homeCentral'
     })
   } else if (id === 'root' || id === undefined){
     this.props.history.push({
       pathname:'/home'
     })
   } else {
     this.props.history.push({
       pathname:'/homeScore'
     })
   }
  }


  async selectdata(type='select'){
   await selectIndex().then(res=>{
       if (res.statecode === 0) {
        const data = res.records[0].annuallist
        const status =  res.records[0].annuallist[0].submit === 'n' ? false : true
        this.setState({
          indexdata:data,
          status:status,
          fileslist:res.records[0].filelist,
          newslist:res.records[0].bulletinlist,
          state:res.records[0].state
        },()=>{
            if (type === 'download') {
                if (this.state.indexdata[this.state.index].appform && this.state.indexdata[this.state.index].appform !==''){
                    window.location.href = this.state.indexdata[this.state.index].appform
                    this.setState({
                        index:-1
                    })
                } else {
                    message.error('申报书生成中，请稍后在尝试下载。',()=>{
                        this.setState({
                            index:-1
                        })
                    })
                }
            }
        })

      } else {
        message.error(res.statemessage);
      }
    })
  }

    componentDidMount(){
    this.selectdata()
  }


  render(){
    const userList = this.props.userList;
    let name = ''
    if (userList!==null && JSON.stringify(userList) !== '{}'){
      name = userList.clerkrealname;
    }
    const userInfo = this.props.userInfo;
    let persontype = []
    if (userInfo !== null) {
      persontype = userInfo[0].clerklist
    }
    const menu = (
        <Menu>
        <Menu.Item>
          <CButton type='text' block onClick={() => this.menuClick()}>个人信息</CButton>
        </Menu.Item>
        </Menu>);
    return (
        <main style={{textAlign:'left'}} className='containerblock'>
          <div className='titles'>
            {/*<img src={logo} alt=""/>*/}
              博物馆运行评估系统
            <div className='flex info-right'>
              <div className='user-info' ref='userInfo'>
                <Dropdown overlay={menu} getPopupContainer={() => this.refs.userInfo}>
                <span>
                  {/*<img className='user-avatar' src={url} alt=""/>*/}
                  <span className='user-name'>
                    {name}</span>
                  <Icon type="down" />
                </span>
                </Dropdown>
                  <span className='logoutindex' onClick={()=>{this.logout()}} style={{marginLeft:'30px',cursor:'pointer',fontSize:'16px'}}>
                    退出
                  </span>
              </div>
            </div>
          </div>
          <div className='contents'>
            <div className='zhibiao'>
              <span>当前进展：{this.state.state}</span>
            </div>
            {this.state.indexdata.length > 0 ?
                <div style={{paddingBottom:'40px'}} className='content-container'>
                  <div className='year-container'>
                    <div className="block1">
                      <div className="text1"><span onClick={() => this.selectAllMenu(Number(this.state.indexdata[0].annual))}>{this.state.indexdata[0].annual?this.state.indexdata[0].annual:''}年度信息申报</span></div>
                          <div className="btn" >
                              {this.state.indexdata[0].submit === '0' ? <label htmlFor="" onClick={() => this.selectAllMenu(Number(this.state.indexdata[0].annual))}>
                                  已填写完成{this.state.indexdata[0].filledcount}项
                                  <span style={{marginLeft:'20px',color:'#3cb9f1',cursor:'pointer'}}>编辑</span>
                              </label>: <label htmlFor="" onClick={() => this.selectAllMenu(Number(this.state.indexdata[0].annual))}>已提交<span style={{marginLeft: '20px',color:'#3cb9f1',cursor:'pointer'}}>查看</span></label>}
                              {this.state.indexdata[0].submit === '0'?'': <div>
                                  <Button type="primary" className="download" onClick={() => this.downloadFile(this.state.indexdata[0].appform,0)}>
                                      申报书下载
                                  </Button>
                              </div>}
                          </div>
                    </div>
                    <div className="block1">
                      <div className="text1"><span onClick={() => this.selectAllMenu(Number(this.state.indexdata[1].annual))}>{this.state.indexdata[1].annual}年度信息申报</span></div>
                          <div className="btn">
                              {this.state.indexdata[1].submit === '0' ? <label htmlFor="" onClick={() => this.selectAllMenu(Number(this.state.indexdata[1].annual))}>
                                  已填写完成{this.state.indexdata[1].filledcount}项
                                  <span  style={{marginLeft:'20px',color:'#3cb9f1',cursor:'pointer'}}>编辑</span>
                              </label>: <label htmlFor="" onClick={() => this.selectAllMenu(Number(this.state.indexdata[1].annual))}>已提交<span style={{marginLeft: '20px',color:'#3cb9f1',cursor:'pointer'}}>查看</span></label>}
                              {this.state.indexdata[1].submit === '0'?'': <div>
                                  <Button type="primary" className="download" onClick={() => this.downloadFile(this.state.indexdata[1].appform,1)}>
                                      申报书下载
                                  </Button>
                              </div>}
                          </div>
                    </div>
                    <div className="block1">
                      <div className="text1"><span onClick={() => this.selectAllMenu(Number(this.state.indexdata[2].annual))}>{this.state.indexdata[2].annual}年度信息申报</span></div>
                          <div className="btn">
                              {this.state.indexdata[2].submit === '0' ? <label htmlFor="" onClick={() => this.selectAllMenu(Number(this.state.indexdata[2].annual))}>
                                  已填写完成{this.state.indexdata[2].filledcount}项
                                  <span  style={{marginLeft:'20px',color:'#3cb9f1',cursor:'pointer'}}>编辑</span>
                              </label>: <label for="" onClick={() => this.selectAllMenu(Number(this.state.indexdata[2].annual))}>已提交<span  style={{marginLeft:'20px',color:'#3cb9f1',cursor:'pointer'}}>查看</span></label>  }
                              {this.state.indexdata[2].submit === '0'?'': <div>
                                  <Button type="primary" className="download" onClick={() => this.downloadFile(this.state.indexdata[2].appform,2)}>
                                      申报书下载
                                  </Button>
                              </div>}
                          </div>
                    </div>
                  </div>
                    {
                        this.state.indexdata[0].submitlabel !=='' &&
                        <div className='operate-block'>
                            {this.state.indexdata[0].submit === '0'?
                               <Button type="primary" className='c-nbutton' onClick={()=>{this.handleSubmit()}}>
                                    {this.state.indexdata[0].submitlabel}
                                </Button>:<Button type="primary" className='c-nbutton' onClick={()=>{this.handleCancel()}}>
                                    {this.state.indexdata[0].submitlabel}
                                </Button>}
                        </div>
                    }
                </div>
               :''
            }
            <div className='system-info'>
              <div className='system-tz'>
                <Card title="通知公告" bordered={false} style={{ width: '100%' }}>
                    {
                        this.state.newslist.length === 0? <Empty></Empty>:
                        this.state.newslist.map(item=>{
                                return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                                    <span>{item.title}</span>
                                    <span>{item.postedtime}</span>
                                </div>
                            })
                    }

                </Card>
              </div>
              <div className='system-file'>
                <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                    {
                        this.state.fileslist.length === 0? <Empty></Empty>:
                            this.state.fileslist.map(item=>{
                                return <div onClick={()=>{this.downloads(item)}} className='new-block' style={{color:'rgb(60, 185, 241)'}}>
                                    {item.title}
                                </div>
                            })
                    }
                </Card>
              </div>
            </div>
          </div>
          <Modal title={this.state.title}
                 visible={this.state.isModalVisible}
                 onCancel={this.handleCanceldialog}
                 centered={true}
                 footer={[
                   <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                     取消
                   </Button>
                 ]}
          >
              <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
              <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
          </Modal>
        </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    breadcrumbData: state.breadcrumbData,
    collapsed: state.collapsed,  // 侧边栏是否展开
    windowInfo: state.windowInfo,
    userInfo: state.userInfo,
    userList:  state.userList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
    setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
    setUserInfo: bindActionCreators(setUserInfo, dispatch),
    setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
    setUserList: bindActionCreators(setUserList, dispatch),
    setMenu:bindActionCreators(setMenu,dispatch),
    setYear:bindActionCreators(setYear,dispatch),
      setLibrary:bindActionCreators(setLibrary,dispatch),
      setLbname:bindActionCreators(setLbname,dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Home);
